const SOURCE_LABELS = {
  youtube: 'YouTube',
  file: 'Video file',
  embed: 'Web video',
  unknown: 'Video',
};

/** Classify how a composition video URL should be rendered in the Videos tab. */
export function classifyVideoUrl(raw) {
  const url = (raw || '').trim();
  if (!url) return { kind: 'empty', url: '' };

  if (/(?:youtube\.com|youtu\.be)/i.test(url)) {
    return { kind: 'youtube', url };
  }

  if (/\.(mp4|webm|ogg|m4v|mov)(\?|#|$)/i.test(url)) {
    return { kind: 'file', url };
  }

  if (/^https?:\/\//i.test(url)) {
    return { kind: 'embed', url };
  }

  return { kind: 'unknown', url };
}

export function getVideoSourceLabel(raw) {
  const { kind } = classifyVideoUrl(raw);
  return SOURCE_LABELS[kind] || SOURCE_LABELS.unknown;
}

/** True when ReactPlayer can seek / read playhead (clip marking from the player). */
export function isReactPlayerControllable(raw) {
  const { kind } = classifyVideoUrl(raw);
  return kind === 'youtube' || kind === 'file';
}

/** Grok Imagine and DreamFace share pages cannot be seeked inside an iframe. */
export function isRemoteShareLink(raw) {
  const url = (raw || '').trim();
  return /grok\.com\/.*imagine\/post\//i.test(url) || /dreamfaceapp\.com/i.test(url);
}

/**
 * Same-origin MP4 proxy so the clip player can seek Grok / DreamFace shares.
 * The stored composition URL stays the original link.
 */
export function sharePlaybackUrl(raw) {
  const url = (raw || '').trim();
  if (!isRemoteShareLink(url)) return url;
  const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  return `${base}/media/clip-stream.mp4?url=${encodeURIComponent(url)}`;
}
